import dayjs from "dayjs";
import {
  IF_NOT_FULL_OPTIONS,
  MATCH_KIND_LABELS,
  MATCH_VISIBILITIES,
} from "../../../pages/canchas/openMatchesModel";

/*
 * Organizer-side view model of an open match ("Falta un jugador"). Reservation rows carry an `openMatch`
 * block (null for ordinary bookings) built by the back (organizerMatchBlock.js):
 * { _id, status, capacity, activePlayers, missing, kind, visibility, ifNotFull, closeAt, pricePerPlayer, players }.
 * Pure helpers shared by the grid, the reservations table and the detail modal; wording and the
 * kind/visibility/ifNotFull labels are the ones the player sees when creating the match.
 */

export const OPEN_MATCH_STATUS_LABELS = {
  open: "Abierto",
  confirmed: "Confirmado",
  cancelled: "Cancelado",
  kept: "Mantenido",
};

export const isOpenMatchRow = (row) => Boolean(row && row.openMatch && typeof row.openMatch === "object");

/** A cancelled match no longer counts as an open match of the club. */
export const countOpenMatches = (rows) =>
  (Array.isArray(rows) ? rows : []).filter((r) => isOpenMatchRow(r) && r.openMatch.status !== "cancelled").length;

/** "Falta 1", "Faltan 3" or "Completo". */
export const missingLabel = (match) => {
  const missing = Number(match?.missing) || 0;
  if (missing <= 0) return "Completo";
  return missing === 1 ? "Falta 1" : `Faltan ${missing}`;
};

/** "Falta 1 · 3/4 jugadores", the text of the grid card. */
export const cardLabel = (match) => `${missingLabel(match)} · ${match.activePlayers}/${match.capacity} jugadores`;

/** "Partido abierto · 3/4", the pill of the reservations table. */
export const pillLabel = (match) => `Partido abierto · ${match.activePlayers}/${match.capacity}`;

export const statusLabel = (status) => OPEN_MATCH_STATUS_LABELS[status] || status || "-";

export const kindLabel = (kind) => MATCH_KIND_LABELS[kind] || kind || "-";

export const visibilityLabel = (value) => MATCH_VISIBILITIES.find((v) => v.value === value)?.label || value || "-";

export const ifNotFullLabel = (value) => IF_NOT_FULL_OPTIONS.find((o) => o.value === value)?.label || value || "-";

/** Close moment as "10/11 15:00 hs" (local time), or "-" when missing or invalid. */
export const closeAtLabel = (closeAt) => {
  const d = dayjs(closeAt);
  return closeAt && d.isValid() ? `${d.format("DD/MM HH:mm")} hs` : "-";
};
